import { render, staticRenderFns } from "./giftcreate.vue?vue&type=template&id=56238a16&scoped=true&"
import script from "./giftcreate.vue?vue&type=script&lang=js&"
export * from "./giftcreate.vue?vue&type=script&lang=js&"
import style0 from "./giftcreate.vue?vue&type=style&index=0&id=56238a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56238a16",
  null
  
)

export default component.exports